import { markInputRule, markPasteRule } from '@tiptap/core';
import { Code } from '@tiptap/extension-code';
import { ReactMarkViewRenderer } from '@tiptap/react';
import { fromWhitespaceCss, toWhitespaceCss } from './whitespace-utils';
import ZyCodeInlineMarkView from './zycode-inline-mark-view';

/* Regexes are slightly modified versions from the original ones in the @tiptap/extension-code package. */

/**
 * Matches a code inline to a `code` on input. Does not allow whitespace at the start or end of the text.
 */
const codeInputRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(`([^`\s][^`]*[^`\s]|[^`\s])`)$/;

/**
 * Matches a code inline to a `code` on paste. Does not allow whitespace at the start or end of the text.
 */
const codePasteRegexNoWhitespaceAtStartOrEnd = /(?:^|\s)(`([^`\s][^`]*[^`\s]|[^`\s])`)/g;

export const ZyCodeInlineHeadless = Code.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            preserveWhitespace: {
                default: false,
                parseHTML: element => {
                    const style = element.getAttribute('style');
                    const match = style?.match(/white-space:\s*([^;\s]+)/);
                    if (match) return fromWhitespaceCss(match[1]).preserveWhitespace;
                    return false;
                },
                renderHTML: attributes => {
                    const css = toWhitespaceCss(!!attributes.preserveWhitespace, attributes.allowWrap !== false);
                    if (!css) {
                        return {};
                    }
                    return { style: `white-space: ${css}` };
                },
            },
            allowWrap: {
                default: true,
                parseHTML: element => {
                    const style = element.getAttribute('style');
                    const match = style?.match(/white-space:\s*([^;\s]+)/);
                    if (match) return fromWhitespaceCss(match[1]).allowWrap;
                    return true;
                },
            },
        };
    },

    addInputRules() {
        return [
            markInputRule({
                find: codeInputRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },

    addPasteRules() {
        return [
            markPasteRule({
                find: codePasteRegexNoWhitespaceAtStartOrEnd,
                type: this.type,
            }),
        ];
    },
});

export const ZyCodeInline = ZyCodeInlineHeadless.extend({
    addMarkView() {
        return ReactMarkViewRenderer(ZyCodeInlineMarkView, { as: 'span' });
    },
});

export default ZyCodeInline;
